function SliderArticles() {
	var swiper = new Swiper(".js-slider-articles", {
        slidesPerView: "auto",
        breakpoints: {
            // when window width is >= 768px
            768: {
                allowTouchMove: false
            }
        }
    });
}

export { SliderArticles };